import React from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import IconPlugins from '@material-ui/icons/Build';
import IconStar from '@material-ui/icons/Star';
import { orange } from '@material-ui/core/colors';

import { MenuGroup, MenuEntry } from '@cedalo/webui-components';

function AdminNavigationExtensionsComponent(/* props */) {
	return null;
	// const { experimental, open, setPluginsOpen, isSelected } = props;
	// return experimental ? (
	// 	<MenuGroup
	// 		open={open}
	// 		onClick={() => setPluginsOpen(!open)}
	// 		label={<FormattedMessage id="Dashboard.plugins" defaultMessage="Plugins" />}
	// 		icon={<IconPlugins />}
	// 	>
	// 		<MenuEntry href="/administration/plugins/opcua" selected={isSelected('plugins')}>
	// 			<FormattedMessage id="Extensions.OPCUA.Menu" defaultMessage="OPC UA Tree" />
	// 			<IconStar fontSize="small" style={{ color: orange[500] }} />
	// 		</MenuEntry>
	// 	</MenuGroup>
	// ) : null;
}

function mapStateToProps({ appState }) {
	return {
		experimental: appState.experimental
	};
}

export const AdminNavigationExtensions = connect(mapStateToProps)(AdminNavigationExtensionsComponent);



// WEBPACK FOOTER //
// /home/travis/build/cedalo/streamsheets-pro-features/packages/webui-extensions/src/AdminNavigationExtensions.js